import { openBlock as l, createElementBlock as a, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M15.358 8.642a2.75 2.75 0 1 0-3.889 3.889 2.75 2.75 0 0 0 3.89-3.89Zm-2.828 1.06a1.25 1.25 0 1 1 1.768 1.768 1.25 1.25 0 0 1-1.768-1.768Z",
  "clip-rule": "evenodd"
}, null, -1), t = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M20.495 5.234c-.132 1.552-.631 3.185-1.392 4.773a.746.746 0 0 1-.189.381 20.626 20.626 0 0 1-2.444 3.719 20.71 20.71 0 0 1-1.6 1.735v3.937a.75.75 0 0 1-.22.53l-2.12 2.121a.75.75 0 0 1-1.202-.195l-1.414-2.828a.75.75 0 0 1-.066-.195c-.475.188-.955.342-1.437.457-.042.01-.084.018-.127.024l-1.27 2.542a.75.75 0 0 1-1.202.195L1.57 18.187a.75.75 0 0 1 .195-1.2l2.54-1.271a1.65 1.65 0 0 1 .026-.128c.114-.482.268-.962.456-1.437a.751.751 0 0 1-.194-.066l-2.829-1.414a.75.75 0 0 1-.194-1.201l2.12-2.121a.75.75 0 0 1 .531-.22h3.936c.546-.565 1.128-1.1 1.736-1.6a20.627 20.627 0 0 1 3.721-2.446c.109-.1.24-.161.376-.185 1.588-.762 3.222-1.262 4.775-1.394a1.594 1.594 0 0 1 1.73 1.73ZM18.892 5a.097.097 0 0 1 .082.027c.017.017.03.042.026.081-.093 1.099-.405 2.273-.894 3.454l-2.668-2.668c1.181-.489 2.355-.8 3.454-.894Zm-7.726 13.598a.75.75 0 0 1 .09.139l.949 1.898 1.165-1.166v-2.32a15.625 15.625 0 0 1-2.204 1.449ZM6.85 10.629a15.61 15.61 0 0 0-1.448 2.204.75.75 0 0 0-.138-.09l-1.898-.948 1.166-1.166H6.85Zm7.148-4.055 3.427 3.427a19.24 19.24 0 0 1-2.114 3.153c-2.065 2.512-4.695 4.447-7.247 5.055-.038.01-.101.002-.162-.053l-2.06-2.06c-.054-.061-.061-.124-.052-.16.608-2.553 2.543-5.183 5.055-7.248a19.23 19.23 0 0 1 3.153-2.114ZM4.78 17.156l-1.414.707 2.771 2.77.707-1.413-.013-.013-2.039-2.04-.012-.011Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  o,
  t
];
function d(r, s) {
  return l(), a("svg", c, [...n]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
